import Marquee from "react-fast-marquee";
import { testimonials } from "../Data/testimonials";

const TestimonialMarquee = () => {
  return (
    <Marquee speed={40} pauseOnHover={true} gradient={false}>
      {testimonials.map((t) => (
        <div
          key={t.id}
          style={{
            marginRight: "40px",
            padding: "10px 20px",
          }}
        >
          {t.text}
        </div>
      ))}
    </Marquee>
  );
};

export default TestimonialMarquee;
